<template>
    <div class="content">
        <a-spin :spinning="centerLoading">
            <a-descriptions style="padding: 10px;" title="街道信息">
                <a-descriptions-item label="负责人">
                    暂无
                </a-descriptions-item>
                <a-descriptions-item label="采集点数量">
                    {{ centerInfo.pointCount }} 个
                </a-descriptions-item>
                <a-descriptions-item label="小区数">
                    {{ centerInfo.centerCount }} 个
                </a-descriptions-item>
                <a-descriptions-item label="所属行政">
                    {{ centerInfo.regionName }}
                </a-descriptions-item>
            </a-descriptions>
        </a-spin>
        <a-space direction="vertical" style="width: 100%">
            <a-card>
                <a-row>
                    <a-form layout="inline">
                        <a-form-item label="查询时间">
                            <a-range-picker v-model="params.time" @change="onChange"/>
                        </a-form-item>
                    </a-form>
                </a-row>
                <a-row :gutter="16" style="padding-top: 24px;">
                    <a-spin :spinning="loading">
                        <p class="p-title">数据采集总量</p>
                        <a-col v-for="(item, index) in typeList" :key="`type-${index}`" :span="6">
                            <trash-collect-amount-card :typeData="item"/>
                        </a-col>
                    </a-spin>
                </a-row>
            </a-card>
            <a-card>
                <a-row style="padding-top: 24px;">
                    <a-spin :spinning="loading">
                        <overview-of-street-collect ref="overviewOfStreetCollect" :houseData="houseData"
                                                    :houseDataBak="houseDataBak"/>
                    </a-spin>
                </a-row>
            </a-card>

            <a-card>
                <a-row :gutter="16">
                    <a-col :span="24">
                        <data-alarm ref="dataAlarm"/>
                    </a-col>
                </a-row>
            </a-card>

            <a-row :gutter="16">
                <a-col :span="12">
                    <heat-map ref="heatMap"/>
                </a-col>

                <a-col :span="12">
                    <curve-line ref="curveLine"/>
                </a-col>
            </a-row>
        </a-space>
    </div>
</template>
<script>
import moment from 'moment'
import curveLine from './component/curveLine'
import heatMap from './component/heatMap'
import dataAlarm from './component/dataAlarm'
import overviewOfStreetCollect from './component/overviewOfStreetCollect'
import {queryCenterTypeApi, queryStreetInfoApi} from '@/api/home'
import trashCollectAmountCard from './component/trashCollectAmountCard'

export default {
    components: {trashCollectAmountCard, overviewOfStreetCollect, dataAlarm, heatMap, curveLine},
    data() {
        return {
            loading: false,
            centerLoading: false,
            centerInfo: {},
            params: {
                time: [moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'), moment().startOf('month').format("YYYY-MM-DD")]
            },
            typeList: [],
            houseData: [],
            houseDataBak: []
        }
    },
    mounted() {
        this.queryStreetInfo()
        this.queryCenterType()
        this.queryStreetAccess(this.params)
        this.$refs.dataAlarm.queryStreetAlarm([this.params.time[0], this.params.time[1]])
        this.$refs.heatMap.queryWeightHeatmap()
        this.$refs.curveLine.queryWeightLinemap()
    },
    filters: {
        filterTime(val) {
            return moment(val).format('YYYY-MM-DD HH:mm:ss') === 'Invalid date' ? '' : moment(val).format('YYYY-MM-DD HH:mm:ss')
        }
    },
    methods: {
        queryStreetInfo() {
            this.centerLoading = true
            queryStreetInfoApi({}, this.$route.query.moduleCode).then(res => {
                this.centerInfo = res.result
                this.centerLoading = false
            })
        },
        onChange(e) {
            this.params.time = e
            this.params.startTime = e[0]
            this.params.endTime = e[1]
            this.queryStreetAccess()
            this.queryCenterType()
        },
        queryStreetAccess() {
            this.params.startTime = this.params.time[0]
            this.params.endTime = this.params.time[1]
            this.$refs.overviewOfStreetCollect.queryStreetAccess(this.params)
        },
        queryCenterType() {
            this.loading = true
            this.params.startTime = this.params.time[0]
            this.params.endTime = this.params.time[1]
            queryCenterTypeApi({...this.params}, this.$route.query.moduleCode).then(res => {
                this.typeList = res.result.typeList
                this.loading = false
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.content {
  background-color: white;
  padding: 15px;

  .p-title {
    font-weight: bolder;
    font-size: larger;
  }
}
</style>
